import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import AdminSideNav from "../../../adminComponents/sidenav";
import AdminHeader from "../../../adminComponents/header";
import AllUser from "./AllUser";

const AllUsers = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          ml: { xs: "0px", md: "200px" },
        }}
      >
        <AdminSideNav />
        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <AdminHeader title={"User Management"} />
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
          }}
        >
          <AllUser />
        </Box>
      </Box>
    </Box>
  );
};

export default AllUsers;
